// SpreadsheetML-based Excel export — no external library required.
// Generates a .xls file that Excel (and LibreOffice) opens natively.

const escapeXml = (val) =>
  String(val ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');

const buildWorksheet = (name, headers, rows) => {
  const xmlRows = [headers, ...rows]
    .map(
      (row) =>
        `<Row>${row
          .map((cell) => `<Cell><Data ss:Type="String">${escapeXml(cell)}</Data></Cell>`)
          .join('')}</Row>`
    )
    .join('');
  return `<Worksheet ss:Name="${escapeXml(name)}"><Table>${xmlRows}</Table></Worksheet>`;
};

const triggerDownload = (xml, filename) => {
  const blob = new Blob([xml], { type: 'application/vnd.ms-excel;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

const XLS_HEADER =
  '<?xml version="1.0"?><?mso-application progid="Excel.Sheet"?>' +
  '<Workbook xmlns="urn:schemas-microsoft-com:office:spreadsheet" ' +
  'xmlns:ss="urn:schemas-microsoft-com:office:spreadsheet">';

/**
 * Export a single-sheet Excel file.
 * @param {string[]} headers - Column headers
 * @param {string[][]} rows - Data rows
 * @param {string} filename - File name (should end in .xls)
 */
export const exportToExcel = (headers, rows, filename) => {
  const xml = XLS_HEADER + buildWorksheet('Export', headers, rows) + '</Workbook>';
  triggerDownload(xml, filename);
};

/**
 * Export a multi-sheet Excel file.
 * @param {{ name: string, headers: string[], rows: string[][] }[]} sheets
 * @param {string} filename
 */
export const exportMultiSheetExcel = (sheets, filename) => {
  const xml =
    XLS_HEADER +
    sheets.map((s) => buildWorksheet(s.name, s.headers, s.rows)).join('') +
    '</Workbook>';
  triggerDownload(xml, filename);
};
